import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PopularProduct } from '../../types/dashboard';

interface PopularProductsProps {
  products: PopularProduct[];
}

const PopularProducts: React.FC<PopularProductsProps> = ({ products }) => {
  const navigate = useNavigate();

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(price);
  };

  // Funções de badges comentadas - podem ser implementadas no futuro
  // const getBadgeType = (index: number) => {
  //   if (index === 0) return 'badge-success';
  //   if (index === 1) return 'badge-accent';
  //   if (index === 2) return 'badge-coffee';
  //   return 'badge-neutral';
  // };

  // const getBadgeText = (index: number) => {
  //   if (index === 0) return '🥇 Mais vendido';
  //   if (index === 1) return '🥈 Popular';
  //   if (index === 2) return '🥉 Em alta';
  //   return 'Popular';
  // };

  // const getRankIcon = (index: number) => {
  //   if (index === 0) return '🏆';
  //   if (index === 1) return '🥈';
  //   if (index === 2) return '🥉';
  //   return `${index + 1}`;
  // };

  return (
    <div className="card card-hover">
      <div className="card-header">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-coffee-100 rounded-xl flex items-center justify-center">
              <svg className="w-5 h-5 text-coffee-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-neutral-900">
                Produtos Mais Populares
              </h3>
              <p className="text-sm text-neutral-500">
                Produtos com maior engajamento
              </p>
            </div>
          </div>
          <button 
            onClick={() => navigate('/products')}
            className="text-coffee-600 hover:text-coffee-700 text-sm font-medium transition-colors duration-200"
          >
            Ver todos →
          </button>
        </div>
      </div>
      
      <div className="card-body">
        {products.length === 0 ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <p className="text-neutral-500 font-medium">Nenhum produto disponível</p>
            <p className="text-neutral-400 text-sm">Adicione produtos para começar a vender</p>
          </div>
        ) : (
          <div className="space-y-4">
            {products.map((product, index) => (
              <div 
                key={product.id} 
                className={`p-4 rounded-xl transition-all duration-200 hover:bg-neutral-50 ${
                  index !== products.length - 1 ? 'border-b border-neutral-100' : ''
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    {/* Ícone simples do produto */}
                    <div className="w-8 h-8 bg-coffee-100 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-coffee-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                    </div>
                    
                    {/* Informações do produto */}
                    <div className="flex-1">
                      <p className="font-semibold text-neutral-900 mb-1">{product.name}</p>
                      <div className="flex items-center space-x-3">
                        <p className="text-sm font-medium text-coffee-600">
                          {formatPrice(product.price)}
                        </p>
                        {/* Notas comentadas - não temos sistema de avaliações implementado ainda */}
                        {/* <div className="flex items-center space-x-1">
                          <svg className="w-4 h-4 text-warning-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.118 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                          </svg>
                          <span className="text-xs text-neutral-600">4.5</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  
                  {/* Badges removidos - podem ser implementados no futuro */}
                  {/* <span className={`badge ${getBadgeType(index)}`}>
                    {getBadgeText(index)}
                  </span> */}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PopularProducts; 